/** HashRouter path printed by OrderStatusQRURL (`https://host/#/o/:token`). */
export const PUBLIC_ORDER_STATUS_ROUTE = "/o/:token";
export function publicOrderStatusPath(token) {
    return `/o/${encodeURIComponent(token.trim())}`;
}
//# sourceMappingURL=publicOrderStatusRoute.js.map